import $ from 'jquery';
import {kill} from './utilities';
// const Waypoint = require('waypoints/lib/noframework.waypoints');
//j
/**
 * navigation module
 * @author hello@bradenericson.com
 * 
 */
export default class Nav {
  constructor(element) {
    this.$el = $(element);
    this.setDefaults();
    this.setBinds();
    this.init();
  }

  setDefaults() {
    //- desktop
    this.$navBtn = this.$el.find('.navBtnContainer');
    this.$navLinks = this.$el.find('.navLinks');
    this.$navLogo = this.$el.find('.navLogo');
    this.$logoLink = this.$el.find('.logoLink');
    this.$navSearchBar = this.$el.find('.navSearchBar');
    this.$navSearchSubmit = this.$el.find('.navSearchSubmit');
    this.$navSearchInput = this.$el.find('.navSearchInput');

    //- mobile
    this.$navBtnMobile = this.$el.find('.navBtnContainerMobile');
    this.$navOverlay = this.$el.find('.navOverlay');
    this.$navMobileInner = this.$el.find('.navMobileInner');
    this.$mobileLink = this.$el.find('.mobileLink');
    this.$mobileNavLogo = this.$el.find('.navLogoBig');
    this.$mobileSearchSubmit = this.$el.find('.mobileSearchSubmit');
    this.$mobileSearchInput = this.$el.find('.mobileSearchInput');
    this.$body = $('body');
  }

  setBinds() {
    this.$navBtn.on('click', this.handleNavBtnClick.bind(this));
    this.$navSearchSubmit.on('click', this.handleSearchClick.bind(this));
    this.$navSearchInput.on('keyup', this.handleSearchKeyUp.bind(this));

    this.$navBtnMobile.on('click', this.handleNavBtnMobileClick.bind(this));
    this.$mobileSearchInput.on('keyup', this.handleMobileSearchKeyUp.bind(this));
    this.$mobileLink.on('click', this.enableScroll.bind(this));
    this.$mobileSearchSubmit.on('click', this.handleMobileSearch.bind(this));
    $(window).on('scroll',this.handleScroll.bind(this));
    this.handleScroll();
  }

  init() {
    setTimeout(this.waypoint.bind(this), 10);
    this.switchNav();
  }

  //- waypoint to change nav display on main page
  waypoint() {
    var $parent = this.$el.parent('.stickyNavContainer');
    var parent = $parent[0];
    if (parent) {
      var waypoint = new Waypoint({
        element: parent,
        handler: (direction) => {
          if (direction === 'down') {
            $parent.addClass('stuck');
            this.$navLinks.addClass('hideLinks');
            this.$navBtn.addClass('showBtn');
            this.$navLogo.addClass('showLogo');
            this.$logoLink.addClass('showLogo');
            this.$navSearchBar.addClass('hideSearch');
          }
          else {
            $parent.removeClass('stuck');
            this.$navLinks.removeClass('hideLinks');
            this.$navBtn.removeClass('showBtn');
            this.$navLogo.removeClass('showLogo');
            this.$logoLink.removeClass('showLogo');
            this.$navSearchBar.removeClass('hideSearch');
          }
        }
      });
    }
  }

  //- shrinks nav an scroll on mobile screens
  handleScroll() {
    if ($(window).scrollTop() > 100) {
      this.$navMobileInner.addClass('onScroll');
    }
    const $parent = this.$el.parent('.stickyNavContainer');
    if ($parent.length) {
      if ($(window).scrollTop() < 50) {
        // do something
        this.$navMobileInner.removeClass('onScroll');
      }
    }

    //- closes open nav menu on scroll only after the nav has passed waypoint
    if ($parent.length && $parent.hasClass('stuck')) {
      this.$navLinks.addClass('hideLinks');
      this.$navBtn.addClass('showBtn');
      this.$navLogo.addClass('showLogo');
      this.$logoLink.addClass('showLogo');
      this.$navSearchBar.addClass('hideSearch');
    }

    this.$mobileSearchInput.removeClass('show');
    this.$mobileNavLogo.removeClass('hide');
  }

  //- handles navBtn click on desktop (toggle nav links and logo)
  handleNavBtnClick(evt) {
    kill(evt);
    this.$navOverlay.toggleClass('openOverlay');
    this.$navBtn.toggleClass('open');
    this.$navLinks.toggleClass('hideLinks');
    this.$navBtn.toggleClass('showBtn');
    this.$navSearchBar.toggleClass('hideSearch');

    // only toggle `showLogo` when nav is `stuck` (otherwise logo link interferes with nav links)
    const $parent = this.$el.parent('.stickyNavContainer');
    const $secondaryParent = this.$el.parent('.fixedNavContainer'); // to handle secondary layout pages

    if($parent.hasClass('stuck') || $secondaryParent.length > 0) {
      this.$navLogo.toggleClass('showLogo');
      this.$logoLink.toggleClass('showLogo');
    }
  }

  //- handles navBtn click on mobile (toggle dropdown)
  handleNavBtnMobileClick(evt) {
    kill(evt);
    //- overlay menu slide up/down
    this.$navOverlay.toggleClass('openOverlay');
    //- hamburger animation
    this.$navBtnMobile.toggleClass('open');
    //- shrink nav down on scroll
    this.$navMobileInner.removeClass('onScroll');
    //- add overflow: hidden to body when overlay is open
    this.$body.toggleClass('disableScroll');
  }

  //- remove overflow: hidden from body when overlay is open
  enableScroll() {
    this.$body.removeClass('disableScroll');
  }

  //- upon hitting subpage, navigation menu hides links and shows logo,
  //- if links are displayed (after navBtn click) hides on scroll
  //- for mobile, upon hitting subpage, nav shrinks just like on scroll
  switchNav() {
    if ($('.stickyNavContainer').length === 0) {
      // this.onScrollNavHide();

      $(window).on('scroll',this.onScrollNavHide.bind(this));
    }
    var $parent = this.$el.parent('.fixedNavContainer');
    if ($parent.length) {
      this.$navMobileInner.addClass('onScroll');
    }
  }

  onScrollNavHide() {
    this.$navLinks.addClass('hideLinks');
    this.$navBtn.addClass('showBtn');
    this.$navLogo.addClass('showLogo');
    this.$logoLink.addClass('showLogo');
    this.$navSearchBar.addClass('hideSearch');
  }

  //- logic handling default behavior of search button
  handleMobileSearch(event) {
    // if(this.$navMobileInner.hasClass('onScroll')) {
    //   this.$mobileNavLogo.addClass('hide');
    //   this.$mobileSearchInput.addClass('show');
    //   event.preventDefault();
    // }

    if (!this.$mobileSearchInput.hasClass('show')) {
      this.$navMobileInner.removeClass('onScroll');
      this.$mobileNavLogo.addClass('hide');
      this.$mobileSearchInput.addClass('show');
      this.$mobileSearchInput.focus();
      event.preventDefault();
      return;
    }
    var query = this.$mobileSearchInput.val().trim();
    if (!query) {
      this.$mobileNavLogo.removeClass('hide');
      this.$mobileSearchInput.removeClass('show');
      return;
    }
    window.location = '/search?q=' + escape(query);

  }

  //- if nav menu is closed, open on search click and prevent default
  handleSearchClick(event) {
    kill(event);
    if (this.$navSearchBar.hasClass('hideSearch')) {
      this.$navLinks.removeClass('hideLinks');
      this.$navBtn.removeClass('showBtn');
      this.$navLogo.removeClass('showLogo');
      this.$logoLink.removeClass('showLogo');
      this.$navSearchBar.removeClass('hideSearch');
      this.$navSearchInput.focus();
    }
    else {
      var query = this.$navSearchInput.val().trim();
      if (query) {
        window.location = '/search?q=' + escape(query);
      }
      else {
        this.$navSearchInput.focus();
      }
    }
  }

  handleSearchKeyUp(e) {
    if (e.keyCode === 13) {
      this.handleSearchClick(e);
    }
  }

  handleMobileSearchKeyUp(e) {
    if (e.keyCode === 13) {
      this.handleMobileSearch(e);
    }
  }

}
